import { compose } from "redux";
import { IAction } from "../../../../models/Action";
import {
  IBREntitlementsItem,
  IBRRequestItem,
  IEntitlementItem,
} from "../../../../models/Entitlements";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IRequestUsers } from "../../../../models/Entitlements";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SHOW_TABLE_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import { IDENTITY_SYSTEM } from "../../../../module/constants";
import { CHECK_PASSWORD_ERROR_CODES } from "../../../../common/TwoFactorAuth/module/constants";

const {
  ADDED_BR,
  ADDED_ENTITLEMENTS,
  BUSINESS_ROLES,
  DELEGATOR,
  DELETED_BR,
  DELETED_ENTITLEMENTS,
  ENTITLEMENTS,
  IS_SELF_SELECTED,
  MODIFIED_BR,
  MODIFIED_ENTITLEMENTS,
  OFFICES,
  PREV_ENTITLEMENTS,
  SELECTED_OFFICE,
  SELECTED_OU,
  SELECTED_USER,
  STEP_FOUR,
  STEP_ONE,
  STEP_THREE_USERS_MANAGEMENT,
  STEP_TWO,
  TOTAL_ENTITLEMENTS,
  USER,
  COMMENT,
  ENTITLEMENTS_BR_SELECTED,
  EXISTING_SAME_DB,
  ATTACHMENTS,
  SELECTED_USERS,
  EXCEPTION_CREATION,
  RESPONSE_STATE,
  ALL_USERS,
  ERROR_MESSAGE,
  ABILITATION_DATE,
  SOD_CONFLICTS,
  IS_COMMENT_COMPULSORY,
  PASSWORD_POLICY,
  PAGINATED_BUSINESS_ROLES,
  PAGINATED_ENTITLEMENTS,
  ROLES,
  CONFIG_BUTTONS,
  CONFIGS,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { entitlementsOu, ...paginationData } = action.payload;
    let mappedResponse: any[] = [];
    let mappedResponseFull: any[] = [];
    entitlementsOu.length > 0 &&
      entitlementsOu
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            application_id: data.application_id,
            identity_system_id: data.identity_system_id,
            chainEntitlementsIds: data.chainEntitlementsIds,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            monoProfilo: data.monoProfilo,
            involvedInSOD: data.involvedInSOD,
            temporary: data.temporary,
            whitelist: data.whitelist,
            organizational_units: data.ous,
            identitySystemId:
              IDENTITY_SYSTEM[
                (data.identity_system_id ||
                  data.identitySystem) as keyof typeof IDENTITY_SYSTEM
              ],
          };
          mappedResponse.push(tempRow);
        });
    entitlementsOu.length > 0 &&
      entitlementsOu.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          application_id: data.application_id,
          identity_system_id: data.identity_system_id,
          chainEntitlementsIds: data.chainEntitlementsIds,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          monoProfilo: data.monoProfilo,
          involvedInSOD: data.involvedInSOD,
          temporary: data.temporary,
          whitelist: data.whitelist,
          organizational_units: data.ous,
          identitySystemId:
            IDENTITY_SYSTEM[
              (data.identity_system_id ||
                data.identitySystem) as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponseFull.push(tempRow);
      });

    const entitlementsRawData = {
      entitlementsOu: mappedResponse,
      ...paginationData,
    };

    return compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PAGINATED_ENTITLEMENTS],
        entitlementsRawData
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_THREE_USERS_MANAGEMENT, PAGINATED_ENTITLEMENTS], {}),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state),

  [actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { businessRoleOu, ...paginationData } = action.payload;
    let mappedResponse: any[] = [];
    businessRoleOu.length > 0 &&
      businessRoleOu.forEach((data: any) => {
        let involvedInSOD = false;
        data.entitlements?.forEach((element: any) => {
          if (element.involvedInSOD) involvedInSOD = true;
        });
        const tempRow: any = {
          entitlement_id: data.codeBusinessRole,
          application_name: data.name,
          application_description: data.description,
          entitlement_name: null,
          entitlement_description: null,
          entitlements: data.entitlements,
          validable: null,
          involvedInSOD: involvedInSOD,
        };
        if (data.entitlements && data.entitlements.length > 0) {
          tempRow.isBR = true;
        }
        mappedResponse.push(tempRow);
      });

    const businessRoleRawData = {
      businessRoleOu: mappedResponse,
      ...paginationData,
    };

    return compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PAGINATED_BUSINESS_ROLES],
        businessRoleRawData
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.MODIFY_SELECTED_USER_MANAGEMENT]: (state: any, action: any) =>
    immutableSet(["selectedUserManagement"], action.user, state),

  [actionTypes.GET_ADMIN_USER_MANAGERS_SUCCESS]: (state: any, action: any) => {
    const mappedRes: any[] = [];
    if (action.payload && action.payload.length > 0) {
      action.payload.forEach((mg: any) => {
        const temp = {
          code: mg.managerCode,
          ouDescription: mg.ouDescription,
          resp_full_name: mg.managerFullName,
        };
        mappedRes.push(temp);
      });
    }
    return immutableSet(["userManagers"], mappedRes, state);
  },
  [actionTypes.GET_ADMIN_USER_MANAGERS_FAILURE]: (state: any, action: any) =>
    immutableSet(["userManagers"], [], state),
  [actionTypes.GET_ADMIN_USER_OUS_SUCCESS]: (state: any, action: any) => {
    const mappedRes: any = [];
    action.payload.forEach((ou: any) => {
      const temp = {
        id: ou.code,
        name: ou.name,
        description: ou.description,
        owner: ou.ownerFullName,
      };
      mappedRes.push(temp);
    });
    return immutableSet(["userOus"], mappedRes, state);
  },
  [actionTypes.GET_ADMIN_USER_OUS_FAILURE]: (state: any, action: any) =>
    immutableSet(["users"], [], state),

  [actionTypes.ADMIN_USERS_REQUEST]: (state: any, action: any) =>
    immutableSet(["usersLoader"], true, state),
  [actionTypes.ADMIN_USERS_REQUEST_SUCCESS]: (state: any, action: any) => {
    const payloadTemp = action.payload;
    payloadTemp &&
      payloadTemp.length > 0 &&
      payloadTemp.map((res: any) =>
        res.delegator ? delete res.delegator : res
      );
    return compose(
      immutableSet(["users"], payloadTemp),
      immutableSet(["usersLoader"], false)
    )(state);
  },
  [actionTypes.ADMIN_USERS_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet(["users"], action.payload),
      immutableSet(["usersLoader"], false)
    )(state),

  [actionTypes.ADMIN_GET_USER_LIST]: (state: any, action: any) =>
    compose(immutableSet(["usersLoader"], true))(state),

  [actionTypes.ADMIN_GET_USER_LIST_SUCCESS]: (state: any, action: any) => {
    const { users, ...paginationData } = action.payload;
    const tempList: any[] = [];
    users.forEach((usr: any) => {
      const tempUsr = {
        uniqueId: usr.id,
        code: usr.code,
        name: usr.name,
        surname: usr.surname,
        email: usr.email,
        organizational_unit: usr.organizational_unit,
        organizational_unit_code: usr.organizational_unit_code,
        type: usr.type,
        supervisorFullName: usr.supervisorFullName,
        identitySystemId:
          IDENTITY_SYSTEM[usr.identitySystemId as keyof typeof IDENTITY_SYSTEM],
      };
      tempList.push(tempUsr);
    });
    const modifieddPayload = {
      ...paginationData,
      users: tempList,
    };
    return compose(
      immutableSet(["rawUsers"], users),
      immutableSet(["usersLoader"], false),
      immutableSet(["users"], modifieddPayload)
    )(state);
  },
  [actionTypes.ADMIN_GET_USER_LIST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet(["usersLoader"], false),
      immutableSet(["users"], [])
    )(state),

  [actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([ALL_USERS], []),
      immutableSet([LOADER_IDENTIFIER], true)
    )(state),
  [actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          uniqueId: data.id,
          accountCode: data.code,
          status: data.status,
          application_name: data.pwdcfg_name,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([ALL_USERS], mappedResponse)
    )(state);
  },
  [actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([ALL_USERS], [])
    )(state);
  },

  [actionTypes.ADMIN_USERS_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const {
      entitlements,
      businessRoles,
    }: { entitlements: IEntitlementItem[]; businessRoles: IBRRequestItem[] } =
      action.payload;
    const tempListItems: IEntitlementItem[] = [];
    if (entitlements.length > 0) {
      entitlements.forEach((entitlement) =>
        tempListItems.push({
          application_id: entitlement.application_id,
          application_name: entitlement.application_name,
          application_description: entitlement.application_description,
          entitlement_id: entitlement.entitlement_id,
          entitlement_name: entitlement.entitlement_name,
          entitlement_description: entitlement.entitlement_description,
          editable: entitlement.editable,
          identity_system_id: entitlement.identity_system_id,
          chainEntitlementsIds: entitlement.chainEntitlementsIds || [],
        })
      );
    }
    if (businessRoles.length > 0) {
      businessRoles.forEach((br) => {
        tempListItems.push({
          application_description: br.description,
          application_name: br.name,
          entitlement_description: "",
          entitlement_name: "",
          entitlement_id: br.id,
          application_id: br.id,
          editable: br.editable,
          entitlements: br.entitlements,
          isBR: true,
          identity_system_id: "",
          chainEntitlementsIds: [],
        });
      });
    }

    return immutableSet(["userEntitlements"], tempListItems, state);
  },

  [actionTypes.ADMIN_USERS_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet(["userEntitlements"], action.payload, state),
  [actionTypes.ADMIN_SET_ENTITLEMENTS_BR_SELECTED]: (
    state: any,
    action: any
  ) => {
    const payloadTemp: IEntitlementItem = action.payload.map(
      (el: IBREntitlementsItem) => {
        return {
          application_id: el.id,
          application_name: el.applicationName,
          application_description: el.applicationDescription,
          entitlement_name: el.entitlementName,
          entitlement_description: el.entitlementDescription,
        } as IEntitlementItem;
      }
    );
    return immutableSet(["entitlementsOfBR"], payloadTemp, state);
  },
  [actionTypes.USER_RESET_STATE]: (state: any, action: any) => emptyState,

  [actionTypes.ENTITLEMENTS_BR_SELECTED_RESET]: (state: any, action: any) =>
    compose(
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          LIST_IDENTIFIER,
        ],
        []
      ),
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          SHOW_TABLE_IDENTIFIER,
        ],
        false
      )
    )(state),
  [actionTypes.ADMIN_ENTITLEMENT_REQUEST_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.ADMIN_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => {
    let objToReturn = {
      entitlements: action.payload.entitlements,
      businessRoles: action.payload.businessRoles,
    };
    return compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LIST_IDENTIFIER],
        objToReturn
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, TOTAL_ENTITLEMENTS],
        objToReturn
      )
    )(state);
  },

  [actionTypes.ADMIN_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LIST_IDENTIFIER],
        {
          businessRoles: [],
          entitlements: [],
        }
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state),

  [actionTypes.ADMIN_SELECT_OFFICE]: (state: any, action: any) =>
    compose(
      immutableSet([SELECTED_USER], []),
      immutableSet([SELECTED_OFFICE], action.id)
    )(state),
  [actionTypes.ADMIN_MODIFY_SELF_SELECTED_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([SELECTED_USER], []),
      immutableSet([IS_SELF_SELECTED], action.isSelfSelected)
    )(state),
  [actionTypes.ADMIN_MODIFY_DELEGATOR_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([DELEGATOR], action.code, state),

  [actionTypes.ADMIN_MODIFY_SELECTED_USERS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([SELECTED_USER], action.selectedUsers, state),

  [actionTypes.ADMIN_MODIFY_SELECTED_OU_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([SELECTED_OU], action.selectedOu, state),
  [actionTypes.ADMIN_MODIFY_ADDED_ABILITATIONS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([ADDED_ENTITLEMENTS], action.addedAbilitations, state),

  [actionTypes.ADMIN_MODIFY_ADDED_BR_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([ADDED_BR], action.addedBR, state),

  [actionTypes.ADMIN_MODIFY_DELETED_ABILITATIONS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([DELETED_ENTITLEMENTS], action.deletedAbilitations, state),

  [actionTypes.ADMIN_MODIFY_MODIFIED_ABILITATIONS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    immutableSet([MODIFIED_ENTITLEMENTS], action.modifiedAbilitations, state),

  [actionTypes.ADMIN_MODIFY_TOTAL_ABILITATIONS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, TOTAL_ENTITLEMENTS],
      action.totalAbilitations,
      state
    ),

  [actionTypes.ADMIN_MODIFY_COMMENT_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([COMMENT], action.comment, state),

  [actionTypes.ADMIN_OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypes.ADMIN_OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([OFFICES], action.payload),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([OFFICES], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_USER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], true, state),

  [actionTypes.ADMIN_USER_REQUEST_SUCCESS]: (state: any, action: any) => {
    const tempUsers: any[] = [];
    action.payload.map((user: IRequestUsers) => {
      const tempUser = {
        id_user: user.id,
        code: user.code,
        name: user.name,
        surname: user.surname,
        organizational_unit: user.organizational_unit,
        resp_code: user.resp_code,
        type: user.type,
        company: user.company,
      };
      tempUsers.push(tempUser);
    });
    return compose(
      immutableSet([STEP_TWO, USER, LIST_IDENTIFIER], tempUsers),
      immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.ADMIN_USER_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, USER, LIST_IDENTIFIER], []),
      immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          application_id: data.application_id,
          identity_system_id: data.identity_system_id,
          chainEntitlementsIds: data.chainEntitlementsIds,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          monoProfilo: data.monoProfilo,
          involvedInSOD: data.involvedInSOD,
          temporary: data.temporary,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LIST_IDENTIFIER],
        []
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LOADER_IDENTIFIER],
        false
      )
    )(state),

  [actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.codeBusinessRole,
          application_name: data.name,
          application_description: data.description,
          entitlement_name: null,
          entitlement_description: null,
          entitlements: data.entitlements,
          validable: null,
        };
        mappedResponse.push(tempRow);
      });

    return compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LIST_IDENTIFIER],
        []
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, BUSINESS_ROLES, LOADER_IDENTIFIER],
        false
      )
    )(state),

  [actionTypes.ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          LIST_IDENTIFIER,
        ],
        action.payload
      ),
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          SHOW_TABLE_IDENTIFIER,
        ],
        true
      )
    )(state),

  [actionTypes.ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          LIST_IDENTIFIER,
        ],
        []
      ),
      immutableSet(
        [
          STEP_THREE_USERS_MANAGEMENT,
          ENTITLEMENTS_BR_SELECTED,
          SHOW_TABLE_IDENTIFIER,
        ],
        false
      )
    )(state),

  [actionTypes.ADMIN_CREATE_REQUEST]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.PENDING, state),

  [actionTypes.ADMIN_CREATE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),
  [actionTypes.ADMIN_CREATE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),

  [actionTypes.ADMIN_SET_EXISTING_SAME_DB]: (state: any, action: any) =>
    immutableSet([EXISTING_SAME_DB], action.payload, state),

  [actionTypes.ADMIN_RESET_ABILITATIONS]: (state: any, action: any) =>
    compose(
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, PREV_ENTITLEMENTS, LIST_IDENTIFIER],
        {
          businessRoles: [],
          entitlements: [],
        }
      ),
      immutableSet(
        [STEP_THREE_USERS_MANAGEMENT, ENTITLEMENTS, LIST_IDENTIFIER],
        []
      ),
      immutableSet([ADDED_ENTITLEMENTS], []),
      immutableSet([DELETED_ENTITLEMENTS], []),
      immutableSet([MODIFIED_ENTITLEMENTS], []),
      immutableSet([DELETED_BR], []),
      immutableSet([MODIFIED_BR], []),
      immutableSet([ADDED_BR], []),
      immutableSet([STEP_THREE_USERS_MANAGEMENT, TOTAL_ENTITLEMENTS], {
        businessRoles: [],
        entitlements: [],
      })
    )(state),

  [actionTypes.ADMIN_RESET_STATE]: (state: any, action: any) => emptyState,

  [actionTypes.ADMIN_SET_SELECTED_USERS]: (state: any, action: any) =>
    compose(immutableSet([EXCEPTION_CREATION, SELECTED_USERS], action.payload))(
      state
    ),

  [actionTypes.ADMIN_RESET_PASSWORD]: (state: any, action: any) =>
    compose(
      immutableSet([RESPONSE_STATE], IResponseState.PENDING),
      immutableSet([ERROR_MESSAGE], "")
    )(state),
  [actionTypes.ADMIN_RESET_PASSWORD_SUCCESS]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_RESET_PASSWORD_FAILURE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),

  [actionTypes.ADMIN_BLOCK_ACCOUNT]: (state: any, action: any) =>
    compose(
      immutableSet([RESPONSE_STATE], IResponseState.PENDING),
      immutableSet([ERROR_MESSAGE], "")
    )(state),
  [actionTypes.ADMIN_BLOCK_ACCOUNT_SUCCESS]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_BLOCK_ACCOUNT_FAILURE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),

  [actionTypes.ADMIN_UNLOCK_PASSWORD]: (state: any, action: any) =>
    compose(
      immutableSet([RESPONSE_STATE], IResponseState.PENDING),
      immutableSet([ERROR_MESSAGE], "")
    )(state),
  [actionTypes.ADMIN_UNLOCK_PASSWORD_SUCCESS]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_UNLOCK_PASSWORD_FAILURE]: (state: any, action: any) =>
    immutableSet([RESPONSE_STATE], IResponseState.ERROR, state),

  [actionTypes.ADMIN_CHANGE_PASSWORD]: (state: any, action: any) =>
    compose(
      immutableSet([RESPONSE_STATE], IResponseState.PENDING),
      immutableSet([ERROR_MESSAGE], "")
    )(state),

  [actionTypes.ADMIN_CHANGE_PASSWORD_SUCCESS]: (state: any, action: any) => {
    let responseState = IResponseState.SUCCESS;
    if (action.payload.responseId === 500) responseState = IResponseState.ERROR;
    return compose(
      immutableSet([RESPONSE_STATE], {
        state: responseState,
        message:
          CHECK_PASSWORD_ERROR_CODES[action.payload.responseCode as string] ??
          action.payload.responseCode,
      }),
      immutableSet([ERROR_MESSAGE], action.payload.responseCode)
    )(state);
  },
  [actionTypes.ADMIN_CHANGE_PASSWORD_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [RESPONSE_STATE],
      {
        state: IResponseState.ERROR,
        message:
          CHECK_PASSWORD_ERROR_CODES[action.payload.responseCode as string] ??
          action.payload.responseCode,
      },
      state
    ),

  [actionTypes.ADMIN_USR_START_END_DATE]: (state: any, action: any) => {
    let data = state.stepThreeUsersManagement.abilitationDate;
    let obj = {
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
      id: action.payload.id,
    };
    data.push(obj);
    return immutableSet(
      [STEP_THREE_USERS_MANAGEMENT, ABILITATION_DATE],
      data,
      state
    );
  },

  [actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], null, state),

  [actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([SOD_CONFLICTS], action.payload, state),

  [actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([SOD_CONFLICTS], IResponseState.ERROR, state),

  [actionTypes.USERS_MANAGEMENT_RESET_SOD_CONFLICTS]: (
    state: any,
    action: any
  ) => immutableSet([SOD_CONFLICTS], null, state),

  [actionTypes.USERS_MANAGEMENT_SET_IS_COMMENT_COMPULSORY_ACTION]: (
    state: any,
    action: any
  ) => immutableSet([IS_COMMENT_COMPULSORY], action.payload, state),

  [actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT]: (state: any, action: any) =>
    immutableSet([PASSWORD_POLICY], {}, state),

  [actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([PASSWORD_POLICY], action.payload, state),

  [actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([PASSWORD_POLICY], {}, state),

  [actionTypes.USERS_MGMT_GET_ROLES_ACTION]: (state: any, action: any) =>
    immutableSet([ROLES], [], state),

  [actionTypes.USERS_MGMT_GET_ROLES_ACTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([ROLES], action.payload, state),

  [actionTypes.USERS_MGMT_GET_ROLES_ACTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([ROLES], [], state),

  [actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], null, state),

  [actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], action.payload, state),

  [actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], null, state),

  [actionTypes.USERS_MGMT_GET_CONFIG_ACTION]: (state: any, action: any) =>
    immutableSet([CONFIGS], null, state),

  [actionTypes.USERS_MGMT_GET_CONFIG_ACTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CONFIGS], action.payload, state),

  [actionTypes.USERS_MGMT_GET_CONFIG_ACTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CONFIGS], null, state),

  [actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], null, state),

  [actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], action.payload, state),

  [actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CONFIG_BUTTONS], null, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
